<template>
    <v-col class="full-height pr-12">
      <v-row class="hide-scrollbar custom-row">
        <v-container>
          <v-col class="text-right">
            <AddForm :data="'Company'" @add="addCompany($event)" />
          </v-col>
          <v-divider class="ma-4"></v-divider>
          <v-container class="d-block">
              <v-card>
                <v-card-title>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                    clearable
                    clear-icon="mdi-close-circle-outline"
                  ></v-text-field>
                </v-card-title>
                <v-data-table
                  :headers="headers"
                  :items="companies"
                  :search="search"
                  :loading="loading"
                  class="elevation-1"
                  loading-text="Loading... Please wait"
                >
                  <template v-slot:[`item.description`]="{ item }">
                    <div
                      class="text-truncate"
                      style="max-width: 500px"
                      :title="item.description"
                    >{{ item.description }}</div>
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-icon class="mx-2" name="delete" @click="goto(item)">mdi-pencil</v-icon>
                    <delete-with-confirm :id="item.name" @deleted="deleteGroup($event)" />
                  </template>
                  <template v-slot:no-data>
                    <span color="primary">No data to show you</span>
                  </template>
                </v-data-table>
              </v-card>
          </v-container>
        </v-container>
      </v-row>
    </v-col>
</template>
<script>
import { mapState } from "vuex";
import AddForm from "@/components/AddForm.vue";
import DeleteWithConfirm from "@/components/DeleteWithConfirm.vue";
import router from "@/router";

export default {
  data: () => ({
    search: "",
    headers: [
      { text: "Name", value: "alias" },
      { text: "Description", value: "description" },
      { text: "Actions", align: "center", value: "action", sortable: false },
    ],
    items: [],
    loading: false,
  }),
  components: {
    AddForm,
    DeleteWithConfirm,
  },
  computed: {
    ...mapState({
      companies: (state) => state.companies,
    }),
  },
  created: async function () {
    this.loading = true;
    await this.$store.dispatch("getGroupTable");
    this.loading = false;
  },
  methods: {
    addCompany: async function (user) {
      const company = {
        name: user.username,
        description: user.description,
        type: "Customer",
      };
      this.loading = true;
      await this.$store.dispatch("putGroupTable", company);
      this.loading = false;
    },
    async goto(item) {
      await this.$store.dispatch("setNameOfCompany", item.name);
      router.push("/admin-customer-users/" + item.alias);
    },
    async deleteGroup(group) {
      this.loading = true;
      await this.$store.dispatch("removeGroup", {
        key: "Customer",
        name: group,
      });
      this.loading = false;
    },
  },
};
</script>
<style scoped>
/* Hide scrollbar for Chrome, Safari and Opera */
.hide-scrollbar::-webkit-scrollbar {
  display: none;
}
/* Hide scrollbar for IE, Edge and Firefox */
.hide-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
  padding-bottom: 10em;
  display: block;
}
.custom-row {
  overflow-y: scroll;
  height: inherit;
}
</style>